// src/components/Privacy.jsx
import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../assets/images/unionIcon.svg';

const Privacy = () => {
    return (
        <Container className="py-5">
            <div className="mb-4">
                <Link to="/login" className="text-decoration-none">
                    ← Back to Login
                </Link>
            </div>

            <Card>
                <Card.Body className="p-4 p-md-5">
                    <div className="text-center mb-4">
                        <img
                            src={logo}
                            alt="KNOKO"
                            style={{maxWidth: '150px', height: 'auto'}}
                            className="mb-3"
                        />
                        <h1>Privacy Policy</h1>
                    </div>

                    <div className="privacy-content">
                        <section className="mb-4">
                            <h2>Introduction</h2>
                            <p>
                                Welcome to KNOKO.ai ("we," "our," or "us"). We are committed to protecting your privacy
                                and ensuring the security of your personal information. This Privacy Policy explains how
                                we collect, use, and safeguard your data when you use our services.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2>Information We Collect</h2>
                            <p>When you use our services, we may collect the following types of information:</p>
                            <ul>
                                <li><strong>Account Information:</strong> Email address, password (encrypted), and profile details</li>
                                <li><strong>Usage Data:</strong> Information about how you interact with our platform</li>
                                <li><strong>Technical Data:</strong> IP address, browser type, device information, and cookies</li>
                                <li><strong>Communications:</strong> Messages and correspondence with our support team</li>
                            </ul>
                        </section>

                        <section className="mb-4">
                            <h2>How We Use Your Information</h2>
                            <p>We use the collected information to:</p>
                            <ul>
                                <li>Provide, maintain, and improve our services</li>
                                <li>Authenticate your identity and manage your account</li>
                                <li>Respond to your inquiries and provide customer support</li>
                                <li>Send important updates about our services</li>
                                <li>Ensure the security and integrity of our platform</li>
                                <li>Comply with legal obligations</li>
                            </ul>
                        </section>

                        <section className="mb-4">
                            <h2>Information Sharing and Disclosure</h2>
                            <p>
                                <strong>We will NOT share your personal information with third parties.</strong> Your data
                                remains private and confidential. We do not sell, rent, or trade your personal information
                                to any external parties.
                            </p>
                            <p>The only exceptions to this policy are:</p>
                            <ul>
                                <li>When required by law or to comply with legal process</li>
                                <li>To protect our rights, property, or safety, or that of our users</li>
                                <li>In connection with a merger, acquisition, or sale of assets (with prior notice to you)</li>
                            </ul>
                        </section>

                        <section className="mb-4">
                            <h2>Data Security</h2>
                            <p>
                                We implement industry-standard security measures to protect your personal information from
                                unauthorized access, disclosure, alteration, or destruction. These measures include:
                            </p>
                            <ul>
                                <li>Encryption of data in transit and at rest</li>
                                <li>Secure authentication and access controls</li>
                                <li>Regular security audits and updates</li>
                                <li>Limited access to personal information by authorized personnel only</li>
                            </ul>
                        </section>

                        <section className="mb-4">
                            <h2>Data Retention</h2>
                            <p>
                                We retain your personal information only for as long as necessary to provide our services
                                and fulfill the purposes outlined in this Privacy Policy. You may request deletion of your
                                account and associated data at any time by contacting us.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2>Your Rights</h2>
                            <p>You have the right to:</p>
                            <ul>
                                <li>Access and review your personal information</li>
                                <li>Request correction of inaccurate or incomplete data</li>
                                <li>Request deletion of your account and personal information</li>
                                <li>Opt-out of non-essential communications</li>
                                <li>Export your data in a portable format</li>
                            </ul>
                        </section>

                        <section className="mb-4">
                            <h2>Cookies and Tracking Technologies</h2>
                            <p>
                                We use cookies and similar tracking technologies to enhance your experience on our platform.
                                These technologies help us remember your preferences, analyze usage patterns, and improve
                                our services. You can control cookie settings through your browser preferences.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2>Children's Privacy</h2>
                            <p>
                                Our services are not intended for children under the age of 13. We do not knowingly collect
                                personal information from children. If you believe we have inadvertently collected information
                                from a child, please contact us immediately.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2>Changes to This Privacy Policy</h2>
                            <p>
                                We may update this Privacy Policy from time to time to reflect changes in our practices or
                                legal requirements. We will notify you of any material changes by posting the updated policy
                                on our website and updating the "Last Updated" date. Your continued use of our services after
                                such changes constitutes acceptance of the updated policy.
                            </p>
                        </section>

                        <section className="mb-4">
                            <h2>Contact Us</h2>
                            <p>
                                If you have any questions, concerns, or requests regarding this Privacy Policy or our data
                                practices, please contact us at:
                            </p>
                            <p>
                                <strong>KNOKO.ai</strong><br />
                                Email: privacy@knoko.ai<br />
                                Website: <a href="https://knoko.ai" target="_blank" rel="noopener noreferrer">https://knoko.ai</a>
                            </p>
                        </section>
                    </div>
                </Card.Body>
            </Card>

            <div className="text-center mt-4">
                <Link to="/login" className="btn btn-primary" style={{ borderRadius: '56px' }}>
                    Back to Login
                </Link>
            </div>
        </Container>
    );
};

export default Privacy;